module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/bl/~/readable-stream/duplex-browser.js
// module id = ../../../../bl/node_modules/readable-stream/duplex-browser.js
// module chunks = 4